export default __webpack_public_path__ + "static/media/220.e56be902.gif";